import { createApp } from 'vue'
import PcTop from '../component/pages/PcTop.vue'

const vue = createApp(PcTop)
    .mount('#pcTop')

export default vue
